import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomLoadingComponent } from './custom-loading';

@NgModule({
  declarations: [
    CustomLoadingComponent,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    CustomLoadingComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class CustomLoadingComponentModule {}
